import React, { PureComponent } from 'react'
import { func } from 'prop-types'
import Button from '@active/react-ui/Button'
import ButtonGroup from '@active/react-ui/ButtonGroup'
import Modal from '@active/react-ui/Modal'
import ModalBody from '@active/react-ui/ModalBody'
import ModalFooter from '@active/react-ui/ModalFooter'
import { getRootElement } from '@active/react-ui/config'

import I18nMessage from '../common/I18nMessage'

class ConfirmPrompt extends PureComponent {
  static propTypes = {
    confirmActionCallback: func.isRequired,
    onClose: func.isRequired,
  }

  componentDidMount() {
    setTimeout(() => {
      const focusElement = getRootElement().querySelector('.passport-ui-app .reagree-waiver__confirm-modal .btn.btn-super')

      if (focusElement) {
        focusElement.focus && focusElement.focus()
      }
    }, 500)
  }

  handleCancelKeyDown = e => {
    const { onClose } = this.props

    if (e.keyCode === 13 || e.keyCode === 32) {
      onClose && onClose(e)
    }
  }

  render() {
    const { onClose, confirmActionCallback } = this.props
    return (
      <Modal
        autoFocusClose
        shown
        onClose={onClose}
        className="passport-ui-app__modal reagree-waiver__confirm-modal"
      >
        <ModalBody>
          <div className="modal-body">
            <p className="passport-ui-app__subTitle passport__pb5">
              <I18nMessage id="passport.privacy.prompt.notice" />
            </p>
            <p className="passport-ui-app__subTitle passport__pb5">
              <I18nMessage id="passport.privacy.prompt.makeSure" />
            </p>
          </div>
        </ModalBody>
        <ModalFooter>
          <ButtonGroup className="passport-content-footer">
            <Button onClick={onClose} type="super" onKeyDown={this.handleCancelKeyDown}>
              <I18nMessage id="passport.common.btn.goBack" />
            </Button>
            <Button type="secondary" onClick={confirmActionCallback}>
              <I18nMessage id="passport.common.btn.signOut" />
            </Button>
          </ButtonGroup>
        </ModalFooter>
      </Modal>
    )
  }
}

export default ConfirmPrompt
